/**
 * chiaveDispositivo.js — come il tablet si presenta al server.
 *
 * La chiave viaggiava nella query string per le GET e nel corpo per le
 * POST. La query string finisce in ogni posto dove un indirizzo viene
 * registrato: il log del server, la cronologia del browser del tablet,
 * l'intestazione Referer, un eventuale proxy in mezzo. Un segreto
 * nell'indirizzo e' un segreto che si copia da solo.
 *
 * Da qui va in un'intestazione. Il nome sta scritto QUI e in un punto
 * solo del backend: scriverlo a mano negli otto punti che la mandano
 * vorrebbe dire che il giorno in cui cambia ne restano due indietro.
 */

export const INTESTAZIONE_DISPOSITIVO = 'X-Dispositivo';

/* Dove il tablet tiene la sua chiave nel browser. Sta qui e non nella pagina
   del tablet perche' la legge anche utils/struttura.js, per chiedere
   l'intestazione del modulo col tablet riconosciuto. */
export const CHIAVE_SALVATA_TABLET = 'rimedichub_dispositivo';

/**
 * Le intestazioni per una richiesta del tablet.
 * @param {string} chiave  la chiave del dispositivo
 * @param {boolean} conCorpo  true se la richiesta manda del JSON
 */
export function intestazioniTablet(chiave, conCorpo = false) {
    const h = {};
    if (conCorpo) h['Content-Type'] = 'application/json';
    if (chiave) h[INTESTAZIONE_DISPOSITIVO] = chiave;
    return h;
}

export default intestazioniTablet;
